(() => {
  const marker = document.getElementById('ov-web-vitals-rum');
  if (!marker || window.__ovWebVitalsRum) return;
  window.__ovWebVitalsRum = true;
  const isTest = marker.dataset.test === '1' || new URL(location.href).searchParams.get('ov_rum_test') === '1';
  if (marker.dataset.preview === '1' && !isTest) {
    marker.dataset.status = 'preview-disabled';
    return;
  }
  const target = 'G-JXDRCRPG1F';
  const pending = new Map();
  const sent = new Map();
  let count = 0;
  let retry = null;
  let observing = false;
  const allowed = () => {
    try {
      const api = window.Shopify?.customerPrivacy;
      marker.dataset.privacy = typeof api?.analyticsProcessingAllowed === 'function' ? 'ready' : 'unavailable';
      if (isTest) {
        marker.dataset.consent = api?.currentVisitorConsent?.().analytics || 'unset';
        marker.dataset.tag = typeof window.gtag;
        marker.dataset.banner = typeof window.privacyBanner?.showPreferences;
        marker.dataset.region = api?.getRegion?.() || 'unknown';
      }
      return api?.analyticsProcessingAllowed() === true;
    }
    catch { return false; }
  };
  const flush = () => {
    if (!allowed()) { marker.dataset.transport = 'consent-not-allowed'; return; }
    if (typeof window.gtag !== 'function') { marker.dataset.transport = 'waiting-for-existing-gtag'; return; }
    marker.dataset.transport = 'existing-gtag';
    for (const [id, metric] of pending) {
      const previous = sent.get(id);
      if (previous === metric.value) { pending.delete(id); continue; }
      const delta = metric.value - (previous ?? 0);
      const params = {
        send_to: target,
        value: Math.round(delta * (metric.name === 'CLS' ? 1000 : 1)),
        metric_name: metric.name,
        metric_value: metric.value,
        metric_delta: delta,
        metric_id: id,
        metric_rating: metric.rating,
        navigation_type: metric.navigationType,
        page_type: marker.dataset.pageType,
        page_path: location.pathname,
        page_location: location.origin + location.pathname,
        viewport_group: innerWidth < 750 ? 'small' : innerWidth < 1080 ? 'medium' : 'large',
        viewport_width: innerWidth,
        viewport_height: innerHeight,
        rum_test: isTest ? '1' : '0',
        rum_version: '6.2.2-ov2',
        non_interaction: true
      };
      if (isTest) params.debug_mode = true;
      try {
        window.gtag('event', metric.name, params);
        sent.set(id, metric.value);
        pending.delete(id);
        marker.dataset.queued = String(++count);
      } catch { marker.dataset.transport = 'tag-error'; }
    }
    marker.dataset.pending = String(pending.size);
  };
  const collect = metric => {
    if (!Number.isFinite(metric.value) || metric.value < 0) return;
    pending.set(metric.id, {name:metric.name, value:metric.value, id:metric.id, rating:metric.rating, navigationType:metric.navigationType});
    marker.dataset['metric' + metric.name] = String(metric.value);
    marker.dataset.pending = String(pending.size);
    flush();
  };
  const start = () => {
    if (observing) return;
    if (!isTest && !allowed()) { marker.dataset.status = 'waiting-for-consent'; return; }
    observing = true;
    marker.dataset.status = 'loading';
    import(marker.dataset.library).then(({onLCP,onINP,onCLS,onFCP,onTTFB}) => {
      onLCP(collect); onINP(collect); onCLS(collect); onFCP(collect); onTTFB(collect);
      marker.dataset.status = 'observing';
      retry = setInterval(() => {
        if (pending.size) flush();
        if (!pending.size && marker.dataset.transport === 'existing-gtag') clearInterval(retry);
      }, 1000);
      setTimeout(() => clearInterval(retry), 30000);
    }).catch(() => { marker.dataset.status = 'library-unavailable'; });
  };
  document.addEventListener('visitorConsentCollected', () => { start(); flush(); });
  if (isTest && marker.dataset.preview === '1') {
    const preferences = document.createElement('button');
    preferences.textContent = 'RUM test: cookie preferences';
    preferences.id = 'ov-rum-test-preferences';
    preferences.style.cssText = 'position:fixed;bottom:8px;left:8px;z-index:999999;padding:12px;background:#fff;color:#000';
    preferences.addEventListener('click', () => {
      window.privacyBanner?.showPreferences?.().catch(() => { marker.dataset.banner = 'error'; });
    });
    document.body.appendChild(preferences);
  }
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
      if (!error) { start(); flush(); }
    });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
  window.addEventListener('pageshow', () => { start(); flush(); });
  start();
})();
